<template>
    <div class="com-column-item" @click.stop="clickItem" v-bind:class="{'com-column-item-cur' : ColumnData.current, 'com-colume-item-choosed' : ColumnData.choosed, 'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
        <!-- 其他信息 -->
        <div class="com-ci-one" v-bind:class="{'com-ci-one-3' : (ColumnData.title.length == 3)}">
            <p v-for="title in ColumnData.title" v-bind:key="'columntitle' + title + Math.random(0, 10)">{{title}}</p>
        </div>
        <!-- 起运前title -->
        <div v-if="showBefore && ColumnData.before" class="com-ci-all dsp-flex">
            <div class="com-ci-all-title">起<br />运<br />前</div>
        </div>
        <template v-else>
            <!-- 天干 -->
            <div class="com-ci-two dsp-flex">
                <div class="com-ci-eight-word" v-bind:class="{'com-ci-eight-word-no-hide': curShowType == 0}">
                    <span v-bind:class="'wd-' + ColumnData.gan.propXingEn">{{ColumnData.gan.text}}</span>
                </div>
                <!-- 隐藏信息:十神/藏干/五行:日干不显示十神 -->
                <div class="com-ci-hide-word" v-if="hasSexIcon">
                    <i class="iconbg icon-sex" v-bind:class="{'icon-male': columnFateData.sex == 0, 'icon-female': columnFateData.sex == 1}"></i>
                </div>
                <div class="com-ci-hide-word" v-if="curShowType == 1 && ColumnData.id != 'day'">
                    <p v-bind:class="'wd-' + ColumnData.gan.propXingEn">{{ColumnData.ganCang[0]}}</p>
                </div>
                <div class="com-ci-hide-word" v-if="curShowType == 3 && ColumnData.id != 'day'">
                    <p v-bind:class="'wd-' + ColumnData.gan.propXingEn">{{ColumnData.ganCang[2]}}</p>
                </div>
            </div>
            <!-- 地支 -->
            <div class="com-ci-three dsp-flex">
                <div class="com-ci-eight-word" v-bind:class="{'com-ci-eight-word-no-hide': curShowType == 0}">
                    <span v-bind:class="'wd-' + ColumnData.zhi.propXingEn">{{ColumnData.zhi.text}}</span>
                </div>
                <!-- 隐藏信息:十神/藏干/五行 -->
                <div class="com-ci-hide-word" v-if="curShowType == 1">
                    <p v-for="hideData in ColumnData.zhiCang[0]"
                        v-bind:key="'hide-word-1' + hideData.color + Math.random(0, 10)"
                        v-bind:class="'wd-' + hideData.color">
                        {{hideData.text}}
                    </p>
                </div>
                <div class="com-ci-hide-word" v-if="curShowType == 2">
                    <p v-for="hideData in ColumnData.zhiCang[1]"
                        v-bind:key="'hide-word-2' + hideData.color + Math.random(0, 10)"
                        v-bind:class="'wd-' + hideData.color">
                        {{hideData.text}}
                    </p>
                </div>
                <div class="com-ci-hide-word" v-if="curShowType == 3">
                    <p v-bind:class="'wd-' + ColumnData.zhi.propXingEn">{{ColumnData.zhiCang[2]}}</p>
                </div>
                <!-- 纳音 -->
                <div v-if="curShowType == 4" class="com-ci-nayin-word" v-bind:class="nayinStyle">
                    <p v-for="nayinText in ColumnData.nayin" class="wd-666">{{nayinText}}</p>
                </div>
            </div>
        </template>
        <!-- 年空、日空 -->
        <div v-if="hasKong && (ColumnData.nianKong || ColumnData.riKong)" class="com-ci-kong-word" :class="{'com-ci-kong-word-side': curShowType == 0}">
            <div v-if="ColumnData.nianKong" class="word-item nian"><p>年</p><p>空</p></div>
            <div v-if="ColumnData.riKong" class="word-item ri"><p>空</p></div>
        </div>

        <!-- 关闭按钮 -->
        <div v-if="hasClose" @click.stop="clickClose" class="com-ci-four" v-bind:class="{'com-ci-four-no-hide': curShowType == 0}">
            <i class="iconfont icon-close-solid com-ci-icon"></i>
        </div>

        <div v-else>
            <!-- 批盘迷你运盘:小红点 -->
            <i v-if="ColumnData.commented" class="iconfont icon-circle-shi com-ci-edited-icon com-ci-edited-icon-red"></i>
            <!-- 批盘迷你运盘:小绿点 -->
            <i v-if="!ColumnData.commented && ColumnData.commentEdited" class="iconfont icon-circle-shi com-ci-edited-icon"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ColumnItem',
    props: {
        ColumnData: {
            type: Object,
            default() { return {} }
        },
        columnFateData: {
            type: Object,
            default() { return {} }
        },
        hasClose: {
            type: Boolean,
            default() { return false }
        },
        hasSexIcon: {
            type: Boolean,
            default() { return false }
        },
        hasKong: {
            type: Boolean,
            default() { return false }
        },
        showBefore: {
            type: Boolean,
            default() { return false }
        },
        nayinStyle: {
            type: String,
            default() { return '' }
        },
        clickFunc: {
            type: Function,
            default() { return undefined }
        },
        closeFunc: {
            type: Function,
            default() { return undefined }
        }
    },
    computed : {
        curShowType() {
            return this.$store.state.setting.curShowType
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    methods:{
        clickItem() {
            if(typeof(this.clickFunc) == 'function'){
                this.clickFunc(this.ColumnData);
            }
        },
        clickClose() {
            if(typeof(this.closeFunc) == 'function'){
                this.closeFunc(this.ColumnData);
            }
        }
    }
}
</script>